import { EntityClient } from "../../entity/EntityClient";

export class DtoClientsPostRes extends EntityClient {}
